import { ConnectionType } from "@/types"
import Cookies from "js-cookie"
import { z } from "zod"

import { getClientId } from "../auth"
import { apiFetch, formatDate } from "../utils"
import { postActivityLog } from "./log"

const billingUrl = `himo-billing/`

//This endpoint used to create new connection type
export async function addConnectionType(data: ConnectionType) {
  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(`${billingUrl}connection-type/`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    if (!response.ok) {
      await postActivityLog({
        menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
        sub_menu_path: "/meter-connection-settings/connection-type",
        action: "Add Connection Type",
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })

      throw new Error(`Error: ${response.statusText}`)
    }

    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/connection-type",
      action: "Add Connection Type",
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    return response.json()
  }

  return null
}

//this endpoint use to retrieved specific connection type
export async function getSelectedConnectionType(
  id: number,
): Promise<ConnectionType> {
  const response = await apiFetch(`${billingUrl}connection-type/${id}/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Error fetching consumer: ${response.statusText}`)
  }
  return response.json()
}

//Used to Edit/Update Connection Type
export async function editConnectionType(
  connectionTypeId: number,
  data: ConnectionType,
) {
  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(
      `${billingUrl}connection-type/${connectionTypeId}/`,
      {
        method: "PUT",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    )
    if (!response.ok) {
      await postActivityLog({
        menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
        sub_menu_path: "/meter-connection-settings/connection-type",
        action: "Update Connection Type",
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })

      throw new Error(`Error: ${response.statusText}`)
    }

    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/connection-type",
      action: "Update Connection Type",
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    return response.json()
  }

  return null
}

//this endpoint use to delete/remove connection type
export async function deleteConnectionType(id: number) {
  const response = await apiFetch(
    `${billingUrl}connection-type/${id}/`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/connection-type/",
      action: `Delete Connection Type (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/connection-type/",
    action: `Delete Connection Type (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  if (response.status === 204) {
    return null
  }

  const contentType = response.headers.get("content-type")
  if (contentType && contentType.includes("application/json")) {
    return response.json()
  } else {
    return null
  }
}
